/* esm.sh - applesauce-core@5.2.0/helpers/relays */
export * from "/*applesauce-core@5.2.0/esnext/helpers/relays.mjs";
